import axios from '../axios'

export const selectPage = (data) => {
    return axios({
        url: '/admin/sourceSubject/selectPage',
        method: 'post',
        data
    })
}
export const insert = (data) => {
    return axios({
        url: '/admin/sourceSubject/insert',
        method: 'post',
        data
    })
}
export const update = (data) => {
    return axios({
        url: '/admin/sourceSubject/update',
        method: 'post',
        data
    })
}

export const batchEnable = (data) => {
    return axios({
        url: '/admin/sourceSubject/batchEnable',
        method: 'post',
        data
    })
}

export const batchDisabled = (data) => {
    return axios({
        url: '/admin/sourceSubject/batchDisabled',
        method: 'post',
        data
    })
}

export const batchDelete = (data) => {
    return axios({
        url: '/admin/sourceSubject/batchDelete',
        method: 'post',
        data
    })
}

export const selectList = (data) => {
    return axios({
        url: '/admin/sourceSubject/selectList',
        method: 'post',
        data
    })
}

export const initGrab = (data) => {
    return axios({
        url: '/admin/sourceSubject/initGrab',
        method: 'post',
        data
    })
}
export const selectById = (params) => {
    return axios({
        url: '/admin/sourceSubject/selectById',
        method: 'get',
        params
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/sourceSubject.js